import { STALE_TIME_L } from "#app/http/ReactQueryProvider";
import { queryKeys } from "#shared/queryKeys/queryKeys";
import { FilterQuery } from "shared";

import { searchTopology } from "./searchTopology.api";

export const searchTopologyQuery = (
  id: string | undefined,
  filterParams: FilterQuery,
  limit = 9,
  shouldReturnChildrenOfAssembly?: boolean,
  dimensionWeight?: number,
) => ({
  queryKey: queryKeys.parts.topology(
    id,
    filterParams,
    limit,
    shouldReturnChildrenOfAssembly,
    dimensionWeight,
  ),
  queryFn: () =>
    searchTopology({ id, filterParams, limit, shouldReturnChildrenOfAssembly, dimensionWeight }),
  staleTime: STALE_TIME_L,
  enabled: !!id,
});
